// extracted by mini-css-extract-plugin
export var modalFooter = "_so-0";